module.exports = __webpack_public_path__ + "static/img/rirekisyo.cc50ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/rirekisyo.png
// module id = Skna
// module chunks = 3